import React from "react";
import SelectList from "views/uikit/FormFields/SelectList";
import { useState } from "react";
import { Modal } from "antd";
import VLButton from "views/uikit/Buttons/VLButton";
import { VLModalTitle } from "views/uikit/VLModalTitle/VLModalTitle";
import styles from "./style.module.scss";

interface SelectClassesModalProps {
  isModalOpen: boolean;
  onCLose: () => void;
  options: { label: string; value: string }[];
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
  loading?: boolean;
  onAdd: () => void;
}

export default function SelectClassesModal({
  isModalOpen,
  onCLose,
  options,
  selectedValues,
  setSelectedValues,
  loading,
  onAdd,
}: SelectClassesModalProps) {
  const [selectOpen, setSelectOpen] = useState(false);
  return (
    <Modal
      open={isModalOpen}
      onCancel={() => {
        setSelectOpen(false);
        onCLose && onCLose();
      }}
      title={
        <VLModalTitle
          title="Add Labels"
          subtitle="Select at least 2 labels to proceed"
        />
      }
      footer={false}
      destroyOnHidden
      afterOpenChange={(open) => {
        setSelectOpen(open);
      }}
    >
      <div className={styles.modalContent}>
        <div className={styles.selectWrapper}>
          <SelectList
            options={options}
            placeholder="Select labels"
            value={selectedValues}
            onChange={setSelectedValues}
            loading={loading}
            mode="multiple"
            open={selectOpen}
            onDropdownVisibleChange={(open) => {
              setSelectOpen(open);
            }}
          />
        </div>
        <div className={styles.buttonWrapper}>
          <VLButton type="primary" onClick={onAdd} text="Add" size="middle" />
        </div>
      </div>
    </Modal>
  );
}
